export enum NotificationAudienceType {
  ALL = "all",
  ORGANIZATION = "organization",
  USERS = "users",
}

export enum NotificationCampaignStatus {
  SENDING = "sending",
  SENT = "sent",
  FAILED = "failed",
}

export enum NotificationChannel {
  APP = "app",
  EMAIL = "email",
}
